<template>
  <v-card flat>
    <v-card-title>
      <p v-if="gindicador">{{gindicador.codigo}} {{gindicador.nombre}}</p>
    </v-card-title>
    <v-card-text>
      <v-container fluid v-if="valPunto">
        <v-row v-if="gficha_indicador!= null">
          <basicos :administrar="false"></basicos>
        </v-row>  
        <v-row>
          <v-col xs12 sm12>
            <v-textarea
              height="200px"
              :readonly="true"
              v-model="valPunto.descripcion"
              label="Descripción:"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              :readonly="true"
              v-model="valPunto.formulacalculo"
              label="Fórmula de cálculo:"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="unidad" label="Unidad de medida:" :readonly="true"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="periodicidad"
              label="Periodicidad de actualización:"
              :readonly="true"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field :readonly="true" v-model="valPunto.diasrezago" label="Días de rezago:"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col xs12 sm12>
            <v-textarea
              :readonly="true"
              v-model="valPunto.metodologiamedicion"
              label="Metodología de medición:"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="valPunto.lineabase === null ">
          <v-col xs12 sm12>
            <v-textarea
              v-model="valPunto.comentariolineabase"
              label="Argumento de porque no tiene línea base:"
              :readonly="true"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="6">
            <v-text-field v-model="valPunto.lineabase" label="Línea base:" :readonly="true"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="formato(valPunto.fechabase)"
              label="Fecha de línea base:"
              :readonly="true"
            ></v-text-field>
          </v-col>
        </v-row>

                  <v-card>
                    <v-card-title>
                      Metas
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetas"
                          :items="gmetasvigenciasinext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        >
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetasCuatrenio"
                          :items="gmetascuatreniosinext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        ></v-data-table>
                      </v-flex>
                      <v-flex xs12 sm2 class="col-padd">
                        <v-text-field
                          readonly
                          v-model="valPunto.meta"
                          label="Meta global"
                        ></v-text-field>


                      </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-card-title>
                      
                      Avance rezagado o posterior a la vigencia PMI
                    </v-card-title>
                    
                    <v-card-text>
                      <v-layout row wrap>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetas"
                          :items="gmetasvigenciaext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        >
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12 sm5 class="col-padd">
                        <v-data-table
                          :headers="headermetasCuatrenio"
                          :items="gmetascuatrenioext"
                          class="elevation-1"
                          :no-data-text="gnodata"
                          :items-per-page="5"
                        ></v-data-table>                      
                      </v-flex>
                      <v-flex xs12 sm2 class="col-padd">
                      </v-flex>   
                      </v-layout>                      
                    </v-card-text>
                  </v-card>         



        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="tipoacumulacion" label="Tipo acumulación:" :readonly="true"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="tipoindicador" label="Tipo de indicador:" :readonly="true"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            Territorialización de indicador:
            <v-radio-group row v-model="valPunto.territorialindicador" :readonly="true">
              <v-radio label="si" :value="true"></v-radio>
              <v-radio label="no" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="4">
            Desagregación poblacional por sexo:
            <v-radio-group row v-model="valPunto.desagregacionpoblacional" :readonly="true">
              <v-radio label="si" :value="true"></v-radio>
              <v-radio label="no" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="4">
            Pertenencia étnica:
            <v-radio-group row v-model="valPunto.pertenenciaetnica" :readonly="true">
              <v-radio label="si" :value="true"></v-radio>
              <v-radio label="no" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="valPunto.territorialindicador">
          <v-col cols="12" md="12">
            <v-select
              :readonly="true"
              :items="gterritorializaciones"
              v-model="territorializacionselect"
              item-text="nombre"
              item-value="idterritorializacion"
              label="Territorialización"
              multiple
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-textarea
              v-model="valPunto.fuenteinformacion"
              label="Fuentes de información:"
              :readonly="true"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-select
              :readonly="true"
              v-model="responsableselected"
              :items="gentidades"
              item-text="nombre"
              item-value="identidad"
              label="Responsable PMI:"
              multiple
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-select
              :readonly="true"
              v-model="entidadselected"
              :items="gentidades"
              item-text="nombre"
              item-value="identidad"
              label="Entidades involucradas:"
              multiple
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-textarea
              v-model="valPunto.observacionadicional"
              label="Observaciones:"
              :readonly="true"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-flex xs12 sm12 class="col-padd">
          <v-textarea
            v-model="valPunto.metastrazadoras"
            label="Metas trazadoras *"
            v-show="clasificacionetnico"
            :readonly="true"
          ></v-textarea>
        </v-flex>

        <v-flex xs12 sm12 class="col-padd">
          <v-textarea
            v-model="valPunto.observacionetnicos"
            label="Observaciones étnico*"
            v-show="clasificacionetnico"
            :readonly="true"
          ></v-textarea>
        </v-flex>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import basicos from "../../components/indicador/basicos";
am4core.useTheme(am4themes_animated);
import store from "../../stores/index.js";
export default {
  name: "detalladoindicador",
  props: {
    getidIndicador: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    basicos,
  },
  data() {
    return {
      valPunto: null,
      visualizacion: 3,
      ultimoavance: null,
      idindicador: null,
      usuarioautenticado: false,
      dialog: false,
      path: process.env.BASE_URL,
      chart: undefined,
      ItemsClasificador: [],
      territorializacionselect: [],
      entidadselected: [],
      responsableselected: [],
      unidad: "",
      periodicidad: "",
      tipoacumulacion: "",
      tipoindicador: "",
      clasificacionetnico: false,
      headermetas: [
        { text: "Año", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" }
      ],
      headermetasCuatrenio: [
        { text: "Periodo", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" }
      ],      
      expanded: [],
      metasvigencia: [],
      MetasCuatrenio: [],
      MetasCuatrenioext: [],
      MetasVigenciaext: [],
      singleExpand: true,
      headers: [
        {
          text: "Año",
          align: "left",
          sortable: false,
          value: "periodo"
        },
        { sortable: false, text: "Meta", value: "valor" },
        { sortable: false, text: "Avance cuantitativo", value: "reporte" },
        {
          sortable: false,
          text: "Porcentaje de avance (%)",
          value: "avancetexto"
        }
      ],
      subheaders: [
        {
          text: "Rango",
          align: "left",
          sortable: false,
          value: "rangoperiodo",
          width: "300px"
        },
        { sortable: false, text: "Meta", value: "valor", width: "5%" },
        {
          sortable: false,
          text: "Avance cuantitativo",
          value: "reporte",
          width: "5%"
        },
        {
          sortable: false,
          text: "Porcentaje de avance (%)",
          value: "avancetexto",
          width: "5%"
        }
      ],

      //plantillas footer data-tables soportecuantitativo
      pageCountSopCuan: 0,
      pageSopCuan: 1,
      itemsPerPageSopCuan: 5,

      //plantillas footer data-tables soportecuantitativo
      pageCountSopCual: 0,
      pageSopCual: 1,
      itemsPerPageSopCual: 5,

      //plantillas footer data-tables soportehito
      pageCountSopHito: 0,
      pageSopHito: 1,
      itemsPerPageSopHito: 5
    };
  },
  methods: {
    ...mapActions([

      "get_metasvigenciaExt",
      "get_metascuatrenioExt",

      "Indicador_Encabezado",
      "get_unidades",
      "getcualitativohistorico",
      "Getperiodicidad",
      "Gettipoacumulacion",
      "getcuantitativohistorico",
      "get_TipoIndicador",
      "get_territorializaciones",
      "Getentidad",
      "getsoportescuantitativos",
      "getsoportescualitativos",
      "get_tiposclasificadorbyindicador"
    ]),
    ...mapActions("fichatecnica/", [
      "set_permitenacional",
      "set_itemsclasificacion",
      "set_indicador",
    ]),
    cambiardecimal(valor) {
      return Intl.NumberFormat("es-CO", { minimumFractionDigits: 1 }).format(
        valor
      );
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    calcularunidad() {
      if (this.gunidades !== undefined) {
        this.unidad = this.gunidades.filter(
          p => p.idunidad === this.gindicador.idunidad
        )[0].nombre;
      } else {
        store.watch(
          () => store.getters["gunidades"],
          () => {
            this.unidad = this.gunidades.filter(
              p => p.idunidad === this.gindicador.idunidad
            )[0].nombre;
          }
        );
      }
    },
    calcularperiodicidad() {
      if (this.gindicador.idperiodicidadactualizacion !== null) {
        if (this.gperiodicidad.length > 0) {
          this.periodicidad = this.gperiodicidad.filter(
            p =>
              p.idperiodicidad === this.gindicador.idperiodicidadactualizacion
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gperiodicidad"],
            () => {
              this.periodicidad = this.gperiodicidad.filter(
                p =>
                  p.idperiodicidad ===
                  this.gindicador.idperiodicidadactualizacion
              )[0].nombre;
            }
          );
        }
      }
    },
    calculartipoacumulacion() {
      if (this.gindicador.idtipoacumulacion !== null) {
        if (this.gtipoacumulacion.length > 0) {
          this.tipoacumulacion = this.gtipoacumulacion.filter(
            p => p.idtipoacumulacion === this.gindicador.idtipoacumulacion
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gtipoacumulacion"],
            () => {
              this.tipoacumulacion = this.gtipoacumulacion.filter(
                p => p.idtipoacumulacion === this.gindicador.idtipoacumulacion
              )[0].nombre;
            }
          );
        }
      }
    },
    calculartipoindicador() {
      if (this.gindicador.idtipoindicador !== null) {
        if (this.gtiposindicador.length > 0) {
          this.tipoindicador = this.gtiposindicador.filter(
            p => p.idtipoindicador === this.gindicador.idtipoindicador
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gtiposindicador"],
            () => {
              this.tipoindicador = this.gtiposindicador.filter(
                p => p.idtipoindicador === this.gindicador.idtipoindicador
              )[0].nombre;
            }
          );
        }
      }
    },
    calcularresponsable() {
      if (this.gindicador.identidadresponsablepmi != undefined) {
        if (this.gentidades !== undefined) {
          this.entidadresponsablepmi = this.gentidades.filter(
            p => p.identidad === this.gindicador.identidadresponsablepmi
          )[0].nombre;
        } else {
          store.watch(
            () => store.getters["gentidades"],
            () => {
              this.entidadresponsablepmi = this.gentidades.filter(
                p => p.identidad === this.gindicador.identidadresponsablepmi
              )[0].nombre;
            }
          );
        }
      }
    }
  },
  created() {
    this.get_unidades();
    this.get_TipoIndicador();
    this.get_territorializaciones();
    this.Getentidad();
    this.Getperiodicidad();
    this.Gettipoacumulacion();
    this.idindicador = this.getidIndicador;
    let IndicadorFichatecnica = this.getidIndicador;

    if (IndicadorFichatecnica > 0)
    {
      this.getcuantitativohistorico({
      params: {
        idindicador: IndicadorFichatecnica
      }
    });
    this.Indicador_Encabezado({
      params: {
        idindicador: IndicadorFichatecnica
      }
    });
      this.get_metascuatrenioExt({
      params: {
        idindicador: IndicadorFichatecnica
      }
    });
      this.get_metasvigenciaExt({
      params: {
        idindicador: IndicadorFichatecnica
      }
    });
      this.getcualitativohistorico({
      params: {
        idindicador: IndicadorFichatecnica
      }
    });
    this.get_tiposclasificadorbyindicador({
        params: {
          IdIndicador: IndicadorFichatecnica,
        },
      });
    }
    this.usuarioautenticado = localStorage.usuario !== undefined;
  },
  computed: {
    ...mapGetters([
      "gmetascuatrenioavance",
      "gmetasvigenciaconavance",
      "gmetasvigenciavencida",

      "gmetasvigenciasinext",
      "gmetascuatreniosinext",
      "gmetasvigenciaext",
      "gmetascuatrenioext",


      "gmetasvigenciavisibles",
      "gindicador",
      "gunidades",
      "gavancecualitativohistoric",
      "gperiodicidad",
      "gtipoacumulacion",
      "gavancecuantitativohistoric",
      "gtiposindicador",
      "gterritorializaciones",
      "gentidades",
      "gultimameta",
      "gsoportescuantitativosaprobados",
      "gsoportescualitativosaprobados",
      "gtiposclasificadorfiltrado",
    ]),
    ...mapGetters("barra", ["gcomparativa"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
    ...mapGetters("fichatecnica", [
      "gficha_permitenacional",
      "gficha_itemsclasificacion",
      "gficha_indicador",
    ]),
  },
  watch: {
    gtiposclasificadorfiltrado: function () {
      this.ItemsClasificador = [];
      if (this.gtiposclasificadorfiltrado.length > 0) {
        this.gtiposclasificadorfiltrado.forEach((element) => {
          this.ItemsClasificador.push(element.idtipoclasificador);
        });
      }
      this.set_itemsclasificacion({
        itemsclasificacion: this.ItemsClasificador,
      });
    },
    gmetasvigenciavisibles: function() {
      this.metasvigencia = this.gmetasvigenciavisibles;
    },
    gindicador: function() {
      this.valPunto = this.gindicador;
      this.set_indicador({ indicador: this.valPunto });
      this.valPunto.indicadorTerritorializaciones.forEach(element => {
        this.territorializacionselect.push(element.idterritorializacion);
      });
      this.valPunto.indicadorEntidades.forEach(element => {
        this.entidadselected.push(element.identidad);
      });
      this.valPunto.indicadorResponsable.forEach(element => {
        this.responsableselected.push(element.identidad);
      });

      this.calcularunidad();
      this.calcularperiodicidad();
      this.calculartipoacumulacion();
      this.calculartipoindicador();
      this.calcularresponsable();
      if (this.valPunto.idclasificacionNavigation.nombre == "Étnico") {
        this.clasificacionetnico = true;
      }
    },
    valPunto: function() {
      if (this.valPunto !== undefined && this.usuarioautenticado === true) {
        this.getsoportescuantitativos({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });
        this.getsoportescualitativos({
          params: {
            idindicador: this.valPunto.idindicador
          }
        });
      }
    },
    gmetasvigenciasinext: function () {
      this.MetasVigencia = this.gmetasvigenciasinext;
    },
    gmetasvigenciaext: function () {
      this.MetasVigenciaext = this.gmetasvigenciaext;
    },
    gmetascuatreniosinext: function () {
      this.MetasCuatrenio = this.gmetascuatreniosinext;
    },
    gmetascuatrenioext: function () {
      this.MetasCuatrenioext = this.gmetascuatrenioext;
    },    
  }
};
</script>
